import { ref } from "vue";

const isBusy = ref(false);

export function useBusyLock() {
  async function runLocked(fn) {
    if (isBusy.value) return; // 이미 실행 중이면 무시
    isBusy.value = true;
    try {
      return await fn();
    } finally {
      isBusy.value = false;
    }
  }

  return { isBusy, runLocked };
}
